import React, { useState, useEffect } from 'react';
import FlipBook from '../components/FlipBook';

const Download = ({ lang }) => {
  const [tomes, setTomes] = useState([]);
  const [complete, setComplete] = useState(null);
  const [openPdf, setOpenPdf] = useState(null);

  useEffect(() => {
    fetch('/api/v1/tomes/' + lang)
      .then(r => r.json())
      .then(d => {
        setTomes(d.tomes || []);
        setComplete(d.complete || null);
      })
      .catch(e => console.error(e));
  }, [lang]);

  const openReader = (url, title) => {
    setOpenPdf({ url, title });
  };

  const closeReader = () => {
    setOpenPdf(null);
  };

  const content = {
    fr: {
      title: 'Télécharger',
      bookTitle: 'Présentation du Livre : « L\'Islam cette lumière pour tous »',
      bookDesc: `Ce document traite de l'Islam qui est la religion que le Seigneur Allah agrée pour toutes Ses créatures humaines et non humaines. Le message islamique parachève tous les messages célestes depuis notre premier ancêtre Adam (que la paix soit avec lui !) et jusqu'au dernier Messager d'Allah Mouhammad (que la paix et les salutations d'Allah soient avec lui !), en passant par les différents messages divins révélés à nos Prophètes et Messagers Noé, Abraham, Moïse, Jésus fils de Marie et les autres (que la paix soit avec eux tous !).

Or de nos jours, constatation faite, la majorité des humains se détournent de l'Islam et le préjugent mal injustement, certainement par ignorance ou d'après le comportement blâmable de nombreux Musulmans qui ignorent beaucoup sur leur religion…

Ce document se veut alors un essai assez complet pour apporter une présentation introductive pour ceux et celles qui ignorent cette religion de Dieu, une présentation convaincante et sans contrainte pour ceux et celles qui rejettent cette religion de Dieu et une présentation corrective pour ceux et celles qui la comprennent ou la pratiquent mal.

C'est un document à vocation pratique dont le contenu suit un cheminement classique mais on y adopte une pédagogie de présentation voulue facile, claire et progressive, pour être bien assimilé et bénéfique pour différentes catégories de gens qui veulent simplement se renseigner sur l'Islam, s'initier ou approfondir leurs connaissances.`,
      complete: 'Livre Complet',
      tomes: 'Par Tome',
      download: 'Télécharger',
      read: 'Feuilleter',
      support: 'Soutenir le projet',
      supportText: 'Si vous souhaitez aider financièrement à la maintenance du site et à la production de nouveaux documents, vous pouvez nous contacter.',
      supportBtn: 'Soutenir le projet'
    },
    en: {
      title: 'Download',
      bookTitle: 'Book Presentation: "Islam: A Light for All"',
      bookDesc: `This document discusses Islam, the religion that the Lord Allah has chosen for all His creatures, human and non-human.

The Islamic message completes all the heavenly messages from our first ancestor, Adam (peace be upon him!), to the last Messenger of Allah, Muhammad (peace and blessings of Allah be upon him!), including the various divine messages revealed to our Prophets and Messengers: Noah, Abraham, Moses, Jesus son of Mary, and others (peace be upon them all!).

However, nowadays, it is clear that the majority of people are turning away from Islam and unjustly misunderstanding and prejudicing it, certainly due to ignorance or the reprehensible behavior of many Muslims who know very little about their religion.

This document aims to be a comprehensive essay, providing an introductory overview for those unfamiliar with this religion of God, a convincing and unbiased presentation for those who reject it, and a corrective explanation for those who misunderstand or practice it badly.

This is a practical document, whose content follows a classic structure, but it adopts a deliberately easy, clear, and progressive presentation method, designed to be easily understood and beneficial to different categories of people who simply want to learn about Islam, become familiar with it, or deepen their knowledge.`,
      complete: 'Complete Book',
      tomes: 'By Book',
      download: 'Download',
      read: 'Read',
      support: 'Support the project',
      supportText: 'If you wish to financially support the maintenance of the site and the production of new documents, you can contact us.',
      supportBtn: 'Support the project'
    }
  };

  const L = content[lang];
  const icons = ['📗', '📘', '📙'];

  // Titres exacts des Tomes/Books
  const tomeTitlesFR = {
    '1': 'Tome 1 La Croyance islamique',
    '2': "Tome 2 L'Adoration et les Pratiques Spirituelles",
    '3': 'Tome 3 Les relations sociales et les comportements'
  };

  const bookTitlesEN = {
    '1': 'Book 1 About Islamic Belief',
    '2': 'Book 2 About Worship and Spiritual Practices',
    '3': 'Book 3 Social relationships and behaviors'
  };

  const displayTomeTitle = (tome) => {
    if (lang === 'fr' && tomeTitlesFR[tome.id]) {
      return tomeTitlesFR[tome.id];
    }
    if (lang === 'en' && bookTitlesEN[tome.id]) {
      return bookTitlesEN[tome.id];
    }
    return tome.title;
  };

  if (openPdf) {
    return (
      <FlipBook
        pdfUrl={openPdf.url}
        title={openPdf.title}
        onClose={closeReader}
        lang={lang}
      />
    );
  }

  return (
    <div className="download">
      <h1>📥 {L.title}</h1>
      
      <section className="book-presentation">
        <h2>{L.bookTitle}</h2>
        <div className="book-desc">
          {L.bookDesc.split('\n\n').map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </section>

      {complete && (
        <section className="download-section">
          <h2>📚 {L.complete}</h2>
          <div className="download-card">
            <span className="download-icon">📕</span>
            <h3>{complete.title}</h3>
            <div className="download-buttons">
              <button onClick={() => openReader(`/api/v1/complete/${lang}/view`, complete.title)} className="btn-read">
                📖 {L.read}
              </button>
              <a href={`/api/v1/complete/${lang}/download`} className="btn-download">
                ⬇️ {L.download}
              </a>
            </div>
          </div>
        </section>
      )}

      <section className="download-section">
        <h2>📖 {L.tomes}</h2>
        <div className="tomes-grid">
          {tomes.map((t, idx) => (
            <div key={t.id} className="download-card">
              <span className="download-icon">{icons[idx] || '📄'}</span>
              <h3>{displayTomeTitle(t)}</h3>
              <div className="download-buttons">
                <button onClick={() => openReader(`/api/v1/tome/${lang}/${t.id}/view`, displayTomeTitle(t))} className="btn-read">
                  📖 {L.read}
                </button>
                <a href={`/api/v1/tome/${lang}/${t.id}/download`} className="btn-download">
                  ⬇️ {L.download}
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="support-section">
        <h2>💝 {L.support}</h2>
        <p>{L.supportText}</p>
        <a href="/support" className="btn-donate">{L.supportBtn}</a>
      </section>
    </div>
  );
};

export default Download;
